import { Sparkles } from "lucide-react";

const ITEMS = [
  "Monte seu copo",
  "Roleta de Açaí R$ 54,90",
  "Açaí do dia R$ 15,00",
  "Entrega e retirada",
  "WhatsApp (41) 3376-7066",
  "300ml até 2 Litros",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative -rotate-1 overflow-hidden border-y border-purple-500/25 bg-[#2D0B5A] py-4"
  >
    <div className="animate-marquee flex w-max items-center gap-12 whitespace-nowrap">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
        <span
          key={i}
          className="flex items-center gap-12 font-grotesk text-sm font-bold uppercase tracking-[0.3em] text-amber-300"
        >
          {t}
          <Sparkles className="h-4 w-4 text-purple-400" />
        </span>
      ))}
    </div>
  </div>
);
